<template>
  <div style="position: relative; height: 100%; width: 100%;">
    <div v-if="loading" class="pie-loading">Načítavam dáta predmetov...</div>
    <div v-else-if="!hasData" class="pie-loading">Žiadne dáta k dispozícii</div>
    <SimplePieChart v-else :chart-data="pieChartData" :chart-options="pieChartOptions" />
  </div>
</template>

<script>
import SimplePieChart from "../SimplePieChart.vue";

export default {
  name: "SubjectPieChart",
  components: { SimplePieChart },

  props: {
    subjectData: { type: Array,   default: () => [] },
    loading:     { type: Boolean, default: false    },
  },

  computed: {
    hasData() {
      return this.subjectData.length > 0;
    },

    pieChartData() {
      const COLORS = [
        "#4CAF50", "#2196F3", "#FF9800", "#E91E63", "#9C27B0",
        "#00BCD4", "#FF5722", "#8BC34A", "#FFC107", "#3F51B5",
        "#009688", "#F44336", "#CDDC39", "#607D8B", "#795548",
      ];

      const sorted = [...this.subjectData].sort(
        (a, b) => b.energy_consumed - a.energy_consumed
      );

      return {
        labels: sorted.map((s) => s.subject_name),
        datasets: [
          {
            data: sorted.map((s) => +s.energy_consumed.toFixed(3)),
            backgroundColor: sorted.map((_, i) => COLORS[i % COLORS.length]),
            borderWidth: 1,
            borderColor: "#fff",
          },
        ],
      };
    },

    pieChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "bottom",
            labels: {
              color: "#f3f4f6",
              font: { size: 12, weight: "600" },
              padding: 15,
            },
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const label = context.label || "";
                const value = context.parsed || 0;
                const total = context.dataset.data.reduce((a, b) => a + b, 0);
                const percentage = ((value / total) * 100).toFixed(1);
                return `${label}: ${value.toFixed(3)} kWh (${percentage}%)`;
              },
            },
          },
        },
      };
    },
  },
};
</script>

<style scoped>
.pie-loading {
  text-align: center;
  color: #d1d5db;
  padding: 40px 0;
  font-size: 0.9rem;
}
</style>